import React from "react";
import type { Breakpoint } from "hooks/useBreakpoint";
import { isFunction, dataFormatters } from "utils";
import { Table as RsuiteTable } from "rsuite";
import styled from "styled-components";

const { Column, HeaderCell, Cell } = RsuiteTable;

// Тип для адаптивного значення
type ResponsiveValue<T> = T | { mobile?: T; desktop?: T };

// Тип для однієї колонки
export interface TableColumn {
    id?: string;
    title?: string;
    label?: string;
    value?: React.ReactNode | ((row: any) => React.ReactNode);
    dataKey: string;
    formatData?: ((value: any, dataKey: string, row: any) => React.ReactNode) | string;
    width?: ResponsiveValue<number>;
    minWidth?: ResponsiveValue<number>;
    flexGrow?: number;
    resizable?: boolean;
    headerProps?: Record<string, any>;
    [key: string]: any;
};

type ResizedWidthData = Record<string, number>;

export const getResponsiveValue = <T,>(value: ResponsiveValue<T>, breakpoint: Breakpoint): T | undefined => {
    if (typeof value === "object" && value !== null && ("mobile" in value || "desktop" in value)) {
        return (value as { [key in Breakpoint]?: T })[breakpoint] ?? value.desktop ?? value.mobile;
    }
    return value as T;
};

export default (props: TableColumn, breakpoint: Breakpoint) => {
    const {
        id,
        title,
        label,
        value,
        dataKey,

        width,
        minWidth,
        flexGrow,
        resizable = false,
        headerProps = {},
        ...restProps
    } = props;

    // const [resizedWidthState, setResizedWidthState] = React.useState<ResizedWidthData>({});

    const colProps: any = { ...restProps, key: id || dataKey };

    const responsiveWidth = getResponsiveValue(width, breakpoint);
    const responsiveMinWidth = getResponsiveValue(minWidth, breakpoint);

    if (typeof width !== "undefined") colProps.width = responsiveWidth;
    if (typeof minWidth !== "undefined") colProps.minWidth = responsiveMinWidth;

    // /*
    //     Тут логіка коли колонки таблиці не resizable.
    //     Якщо колонки не resizable, то ми використовуємо responsiveWidth та responsiveMinWidth
    //     для визначення ширини колонки.
    // */

    const handleResize = (width: number, resizedDataKey: string) => {
        // setResizedWidthState((prevState) => ({
        //     ...prevState,
        //     [resizedDataKey]: width
        // }));

        const currentResizedWidthData: ResizedWidthData = JSON.parse(localStorage.getItem(resizedKey) || "{}");
        localStorage.setItem(resizedKey, JSON.stringify({
            ...currentResizedWidthData,
            [resizedDataKey]: width
        }));
    };

    if (!resizable) {
        if (responsiveMinWidth) {
            colProps.minWidth = responsiveMinWidth;
        }

        if (responsiveWidth && !responsiveMinWidth) {
            colProps.width = responsiveWidth;
        }

        if (!responsiveWidth && flexGrow) {
            colProps.flexGrow = flexGrow || 1;
        }
    } else {
        colProps.onResize = handleResize;
    }

    // /*
    //     Тут логіка коли колонки таблиці resizable
    // */

    const location = window.location;
    const pathName = location.pathname.replace("/", "");

    const resizedKey = `resizedWidth-${pathName}`;
    var resizedWidthData: ResizedWidthData = JSON.parse(localStorage.getItem(resizedKey) || "{}");

    resizedWidthData = resizedWidthData !== null ? resizedWidthData : {};
    const resizedWidth = resizedWidthData[dataKey];

    if (resizable && resizedWidth && (!responsiveMinWidth || resizedWidth >= responsiveMinWidth)) {
        colProps.width = resizedWidth;
    } else {
        if (responsiveMinWidth && (!resizedWidth || resizedWidth < responsiveMinWidth)) {
            if (responsiveWidth && responsiveMinWidth && responsiveWidth >= responsiveMinWidth) {
                colProps.width = responsiveWidth;
            } else {
                colProps.width = responsiveMinWidth;
            }
        } else {
            if (responsiveWidth && !responsiveMinWidth) {
                colProps.width = responsiveWidth;
            }
        }
    }

    return (<Column {...colProps} resizable={resizable}>
        <HeaderCell {...headerProps}>{label}</HeaderCell>
        {typeof value === "function" ? (
            <Cell dataKey={dataKey}>{value}</Cell>
        ) : (
            <Cell dataKey={dataKey} />
        )}
    </Column>);
};